// extracted by mini-css-extract-plugin
export default {"content":"Header_content__wfjeC","buttonContainer":"Header_buttonContainer__BhLPG","job":"Header_job__buZ+J","details":"Header_details__+IIeZ","header":"Header_header__tnNwf"};